import React from 'react';
import logo from '../TBL Logo White.png';
import './QuestionScreen.css';

const QuestionScreen = ({ question, questionNumber, totalQuestions, onAnswer, onBack }) => {
  const handleOptionClick = (option) => {
    onAnswer({
      questionId: question.id,
      category: question.category,
      value: option.value,
      text: option.text
    });
  };

  const handleContinue = () => {
    // For breaker screens, we don't need to save an answer, just continue to next question
    onAnswer({
      questionId: question.id,
      category: question.category,
      value: 'continue',
      text: 'continue'
    });
  };

  // Check if this is a breaker screen
  const isBreaker = question.type === 'breaker';

  return (
    <div className="question-screen">
      <div className="question-header">
        <button className="back-button" onClick={onBack}>
          ← Back to Home
        </button>
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${(questionNumber / totalQuestions) * 100}%` }}
          ></div>
        </div>
        <div className="question-counter">
          {isBreaker ? `Section ${Math.ceil(questionNumber / 7)} of 3` : `Question ${questionNumber} of ${totalQuestions}`}
        </div>
      </div>

      <div className="question-content">
        {isBreaker ? (
          // Breaker screen layout
          <div className="breaker-content">
            <h1 className="breaker-title">{question.title}</h1>
            <div className="breaker-instructions">
              {question.instructions.split('\n').map((line, index) => (
                <p key={index} className="instruction-line">
                  {line}
                </p>
              ))}
            </div>
            <button className="continue-button" onClick={handleContinue}>
              Continue
            </button>
          </div>
        ) : (
          // Regular question layout
          <>
            <h2 className="question-text">{question.question}</h2>
            {question.subtitle && <h3 className="question-subtitle">{question.subtitle}</h3>}
            
            <div className="options-container">
              {question.options.map((option, index) => (
                <button
                  key={index}
                  className="option-button"
                  onClick={() => handleOptionClick(option)}
                >
                  {option.text}
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      <div className="footer">
        <div className="footer-separator"></div>
        <img src={logo} className="footer-logo" alt="TBL Logo" />
      </div>
    </div>
  );
};

export default QuestionScreen;
